<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p class="error-message">
    {{ data.message }}
  </p>
</div>

